import authenticationSaga from 'containers/Authentication/saga';

export default [authenticationSaga];
